import React from "react";
import { FALL_TYPES } from "../../common/constant";
import "./style.scss";

const AnimationBackground = (props: any) => {
  const { icons, type, leafStyle } = props;

  const randomNumber = (number: number) => Math.floor(Math.random() * number);

  const snowEl: any = document.querySelectorAll(".snowflake");

  React.useEffect(() => {
    if (snowEl && type === FALL_TYPES.FULL_FALL) {
      snowEl.forEach((e: any) => {
        const screenOffset = "100px";
        const fallDuration = 5;
        const windNoise = 20;
        const windSpeed = 10;
        const sizeNoise = 30;
        const rotation = 720;
        const scale =
          1 + (randomNumber(2 * sizeNoise * 10) / 10 - sizeNoise) / 100;
        const left = randomNumber(100);
        const deltaLeft =
          randomNumber(2 * windNoise * 10) / 10 - windNoise + windSpeed;

        const newAnimation = [
          {
            left: `${left}%`,
            top: `calc(0% - ${screenOffset})`,
            transform: `scale(${scale}) rotate3d(${randomNumber(100) / 100}, ${
              randomNumber(100) / 100
            }, ${randomNumber(100) / 100}, 0deg)`,
          },
          {
            left: `${left + deltaLeft}%`,
            top: `calc(100% + ${screenOffset})`,
            transform: `scale(${scale}) rotate3d(${randomNumber(100) / 100}, ${
              randomNumber(100) / 100
            }, ${randomNumber(100) / 100}, ${
              (randomNumber(rotation) + rotation) *
              ((randomNumber(2) - 1) * 2 - 1)
            }deg)`,
          },
        ];

        const newTiming = {
          duration:
            (fallDuration + randomNumber(fallDuration * 10) / 10) * 1000,
          iterations: Infinity,
          easing: "linear",
          delay:
            (randomNumber(2 * fallDuration * 10) / 10 - 2 * fallDuration) *
            1000,
        };
        e.animate(newAnimation, newTiming);
      });
    }
  }, [snowEl]);

  const renderAnimationBg = () => {
    if (type === FALL_TYPES.FULL_FALL) {
      return (
        <div className="snowfall">
          {icons.map((icon: string, i: number) => (
            <div className="snowflake" key={i}>
              <img src={icon} />
            </div>
          ))}
        </div>
      );
    } else {
      return (
        <div className="bg-leaf" id="leaf" style={leafStyle}>
          {Array(5)
            .fill(null)
            .map((_: any, i: number) => (
              <img
                key={i}
                id={`leaf-${i + 1}`}
                className="img-leaf"
                src={icons.length ? icons[i % 2] : ""}
                alt=""
              />
            ))}
        </div>
      );
    }
  };

  return renderAnimationBg();
};

export default AnimationBackground;
